import { Injectable } from '@angular/core';
import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';

/**
 * In-house replacement for Material's `ErrorStateMatcher`
 * (`@angular/material/core`), dropped as part of removing the
 * `@angular/material` dependency. Same contract and default behaviour: a control
 * is in an error state when it is invalid AND either touched or its parent form
 * has been submitted.
 *
 * Root-provided so it doubles as the injection token and the default instance —
 * `<app-input>` / `<app-select>` inject it `@Optional()`, and consumers can
 * supply a custom matcher through the `errorStateMatcher` Input (a class that
 * `implements ErrorStateMatcher`).
 */
@Injectable({ providedIn: 'root' })
export class ErrorStateMatcher {
  isErrorState(
    control: AbstractControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    return !!(
      control &&
      control.invalid &&
      (control.touched || (form && form.submitted))
    );
  }
}

/**
 * The default rule, except that a `maxlength` error shows at once: a value set
 * by code (a template, a saved message) can breach the limit before anything
 * is typed, and `setValue` marks nothing touched.
 */
export class EagerMaxLengthErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: AbstractControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    if (!control?.invalid) return false;

    return (
      control.hasError('maxlength') || control.touched || !!form?.submitted
    );
  }
}
